// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/Images/Packages/Packages_BG.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/Images/Packages/BG_2Option_Small.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/Images/Packages/BG_2Option_Large.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../public/Images/Misc/PackageBackButton.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#packagesRoot {
    position: relative;
    display: flex;

    justify-content: center;
    align-items: center;

    width: 100%;
    height: 100%;

    background-color: black;
}

#packagesParent {
    display: flex;
    aspect-ratio: 16/9;
    width: 100%;
    max-width: 177.778vh;
    max-height: 56.25vw;
    height: auto;

    opacity: 1;

    overflow: hidden;

    justify-content: center;
    align-items: end;
    container-type: size;

    z-index: 100;
}

#foreground {
    position: absolute;

    width: 100cqw;
    height: 100cqh;

    left: 50%;
    transform: translate(-50%);

    align-items: center;
    justify-content: center;

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: contain;
    background-repeat: no-repeat;

    opacity: 0;
    

    z-index: 0;
/* 
    justify-self: center;
    align-self: center; */
}

.foreground_IntroAnim {
    animation: fade-in 0.2s ease 0.6s 1 normal forwards running;
}

.foreground_OutroAnim {
    animation: fade-out1 0.3s ease-out 0.7s 1 normal forwards running;
}

#carImage {
    position: absolute;
    aspect-ratio: 16/9;

    width: 111cqw;
    height: auto;

    transform: translate(0%, -8cqh);

    z-index: -1;

    /* box-shadow: none !important; */

    pointer-events: none;

    align-self: flex-end;

    border: none;
}

#carImageDiv {
    position: absolute;
    aspect-ratio: 16/9;

    width: 100cqw;
    height: auto;

    overflow: hidden;

        pointer-events: none;
}

#carImage2 {
    position: absolute;
    aspect-ratio: 16/9;

    width: 118cqw;
    height: auto;

    transform: translate(-50%, -20cqh);
    left:50%;

    

    z-index: -1;

    /* box-shadow: none !important; */

    pointer-events: none;

    align-self: flex-end;

    border: none;
}

.carImageClass_Intro {
    opacity: 0;
    animation: fade-in 1s ease 1.2s 1 normal forwards running;
}

.carImageClass_Outro {
    opacity: 1;
    animation: fade-out1 0.3s ease-out 0.4s 1 normal forwards running;
}

#backgroundColor {
    position: absolute;

    background-color: #dddddd;

    aspect-ratio: 16/9;
    width: 100%;
    max-width: 177.778vh;
    max-height: 56.25vw;
    height: auto;
}

.backgroundClass_Intro {
    opacity: 0;
    animation: fade-in 0.2s ease 0.2s 1 normal forwards running;
}

.backgroundClass_Outro {
    opacity: 1;
    animation: fade-out1 0.3s ease-out 0.7s 1 normal forwards running;
}

#optionHolder {
    /* background-color: aqua; */
    
    display: flex;

    width: 100%;
    height: 34%;

    background-color: transparent;

    flex-direction: row;
    justify-content: center;
}

.optionHolder_Intro {
    opacity: 0;
    animation: fade-in 0.2s ease 0.9s 1 normal forwards running;
}

.optionHolder_Outro {
    opacity: 1;
    animation: fade-out1 0.3s ease-out 0.1s 1 normal forwards running;
}

#option1of2 {
    height: 100%;
    width: 34%;
    margin: 0px 0px 0.3% 0px;

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    background-size: contain;

    opacity: 1;

    z-index: 1;
 
    container-type: size;
}

#option2of2 {
    height: 100%;
    width: 49.5%;

    margin: 0px 0px 0.3% 0px;

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-repeat: no-repeat;
    background-size: contain;

    opacity: 1;

    z-index: 1;

    container-type: size;
}

#option1of2 h2 {
    position: relative;
    top: 15cqh;
    margin: 0;

    font: 13cqh Diesel;
    letter-spacing: 0.4cqh;

    text-transform: uppercase;

    justify-self: center;
    text-align: center;
}

#option1of2 h3 {
    position: relative;
    top: 14cqh;

    margin: 0;

    font: bold 4.3cqh MyriadPro-Regular;
    letter-spacing: 0.1cqw;
    color: transparent;
    text-transform: uppercase;

    justify-self: center;
    text-align: center;

    pointer-events: none;
}

#option1of2 h3::selection {
    color: transparent;
    background-color: transparent;
}

#option1of2 .lineBottom {
    top: 30cqh;
}

#option1of2 button {
    display: block;
    position: relative;

    left: 50%;
    transform: translate(-50%);
    top: 35%;

    width: 32%;
    height: 10%;

    background-color: rgb(136, 46, 46);
    color: #e0e0df;

    z-index: 1000;

    font: 4cqh MyriadPro-Bold;

    text-transform: uppercase;
    letter-spacing: 0.15cqw;

    box-shadow: none;
    border-style: solid;

    border-radius: 25cqh;
    border-color: rgb(136, 46, 46);;

    pointer-events: all;
}

#option1of2 button:hover {
    background-color: transparent;
    color: black;
}

#option2of2 button {
    display: block;
    position: relative;

    left: 50%;
    transform: translate(-50%);
    top: 30.2%;

    width: 22%;
    height: 10%;

    background-color: rgb(136, 46, 46);
    color: #e0e0df;

    z-index: 1000;

    font: 4cqh MyriadPro-Bold;
    text-transform: uppercase;
    letter-spacing: 0.15cqw;

    box-shadow: none;
    border-style: solid;
    border-radius: 25cqh;
    border-color: rgb(136, 46, 46);

    pointer-events: all;
}

#option2of2 button:hover {
    background-color: transparent;
    color: black;
}

.lineTop {
    display: block;
    position: relative;
    top: 21cqh;

    margin: 0;

    width: 90cqw;
    height: 1cqh;

    transform: translate(-50%);
    left: 50%;

    opacity: 0.2;
}

.lineBottom {
    display: block;
    position: relative;

    width: 90cqw;
    height: 1cqh;

    opacity: 0.2;
    
    transform: translate(-50%);
    left: 50%;
}

#option2of2 h2 {
    position: relative;
    top: 15cqh;
    margin: 0;

    font: 13cqh Diesel;
    letter-spacing: 0.4cqh;

    text-transform: uppercase;

    justify-self: center;
    text-align: center;
}

#option2of2 h3 {
    position: relative;
    top: 14cqh;

    margin: 0;

    font: 4.3cqh MyriadPro-Semi;
    letter-spacing: 0.1cqw;
    color: grey;
    text-transform: uppercase;

    justify-self: center;
    text-align: center;
}

#option2of2 .lineBottom {
    top: 25cqh;
}

#option1_Highlight {
    position: absolute;

    width: 99.7cqw;

    opacity: 0;
}

#option2_Highlight {
    position: absolute;

    width: 99.68cqw;

    opacity: 0;
}

.optionFadeOut {
    animation: fade-out1 0.5s ease 0.0s 1 normal forwards running;
}

.optionFadeIn {
    animation: fade-in 0.7s ease 0s 1 normal forwards running;
}

.Start_optionFadeIn {
    animation: fade-in 1s ease 1.2s 1 normal forwards running;
}

.carImage_FadeOut {
    animation: fade-out1 0.25s ease 0.0s 1 normal forwards running;
}

.carImage_FadeIn {
    animation: fade-in 0.25s ease 0.0s 1 normal forwards running;
}



#interactionBlocker-PackageSelection {
    position: absolute;
    width: 100vw;
    height: 100vh;

    z-index: 99;
}

.interactionBlockStart-PackageSelection {
    animation-duration: 1.8s;
    animation-name: remove-blocker;
    animation-fill-mode: forwards;
}

.interactionBlockEnabled-PackageSelection {
    pointer-events: all;
}

.interactionBlockDisabled-PackageSelection {
    pointer-events: none;
}

#backDiv {
    position: absolute;
    aspect-ratio: 16/9;
    width: 100%;
    max-width: 177.778vh;
    max-height: 56.25vw;
    height: auto;

    opacity: 0;

    animation: fade-in 0.2s ease 0.6s 1 normal forwards running;

    pointer-events: none;
}

#inputDiv1_Package {
    position: relative;
    height: 100%;
    width: 54.2%;

    z-index: 2;
    opacity: 0;

    animation-duration: 0.3s;
    animation-name: fade-in;
    animation-fill-mode: forwards;

    pointer-events: none;

    margin-right: -8%;

    object-fit: overflow;
    overflow: hidden;

    clip-path: polygon(0% 0%, 85.3% 0%, 99.9% 51%, 85.7% 100%, 0% 100%);
}

#inputDiv2_Package {
    position: relative;

    height: 100%;

    z-index: 1;
    opacity: 0;

    animation-duration: 0.3s;
    animation-name: fade-in;
    animation-fill-mode: forwards;
    animation-delay: 0.4s;

    pointer-events: none;

    margin-left: 0%;
    margin-right: -4.94791666%;

    overflow: hidden;

    clip-path: polygon(0% 0%, 87% 0%, 100% 51%, 87.6% 100%, 0% 100%, 0% 51%);
}

#inputDiv3_Package {
    position: relative;

    height: 100%;
    width: 54.2%;
    
    right: 0%;

    z-index: 0;
    opacity: 0;

    animation-duration: 0.3s;
    animation-name: fade-in;
    animation-fill-mode: forwards;
    animation-delay: 0.4s;

    pointer-events: none;

    clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%, 12.9% 50%);
}

.fadeIn5 {
    opacity: 0;

    animation-duration: 0.3s;
    animation-name: fade-in;
    animation-fill-mode: forwards;
    animation-delay: 1.5s;
}

/* text */
#inputDiv1_Package h2 {
    text-wrap: nowrap;
}

#inputDiv2_Package h2 {
    white-space: nowrap;
}


#inputDiv3_Package h2 {
    white-space: nowrap; 
}

#inputDiv3_Package h3 {
    white-space: nowrap;
}

#option1of2 ul li:before {
    content: "- ";
}

#option2of2 ul li:before {
    content: "- ";
}

#inputDiv2_Package ul {
    position: absolute;
    list-style: none;

    left: 50%;
    transform: translate(-35%);
    bottom: 20%;

    width: 60%;

    z-index: 5;
    color: white;
}

#inputDiv2_Package ul li:before {
    content: "- ";
}

#inputDiv3_Package ul {
    position: absolute;
    list-style: none;

    left: 50%;
    transform: translate(-45%);
    bottom: 20%;

    z-index: 5;
    color: white;
    text-wrap: nowrap;
}

#inputDiv3_Package ul li:before {
    content: "- ";
}

#optionsContainer1_package {
    position: absolute;

    width: 100%;
    height: 100%;

    left: 27%;
    top: 0%;

    container-type: size;
}

#optionsContainer1_package h2 {
    position: absolute;

    left: 32.29%;
    transform: translate(-50%);
    top: 1%;

    margin: 0px;

    z-index: 5;
    font: 4cqh Diesel;
    letter-spacing: 0.05em;
    text-transform: uppercase;
}

#optionsContainer2_package {
    position: absolute;

    width: 100%;
    height: 100%;

    left: 16%;
    top: 0%;

    container-type: size;
}

#optionsContainer2_package h2 {
    position: absolute;

    left: 58.2%;
    transform: translate(-50%);
    top: 1%;

    margin: 0px;

    z-index: 5;

    font: 4cqh Diesel;
    letter-spacing: 0.05em;
    text-transform: uppercase;
}

#optionsContainer3_package {
    position: absolute;

    width: 100%;
    height: 100%;

    left: 16.2%;
    top: 0%;

    container-type: size;
}

#optionsContainer3_package h2 {
    position: absolute;

    left: 43%;
    transform: translate(-50%);
    top: 1%;

    margin: 0px;

    z-index: 5;

    font: 4.0cqh Diesel;
    letter-spacing: 0.05em;
    text-transform: uppercase;
}

#optionsContainer3_package h3 {
    position: absolute;

    left: 57.9%; 
    transform: translate(-50%);
    top: 5%;

    padding-top: 0;
    margin-top: 0;

    z-index: 5;
    font: 1.2cqh MyriadPro-Regular;
    text-transform: uppercase;
    letter-spacing: 0.3cqh;
    color: black;
}

#optionsContainer2_package ul {
    position: absolute;
    list-style: none;

    left: 55%;
    top: 11.5%;

    width: 55%;

    font: 1.8cqh MyriadPro-Regular;
}

#optionsContainer3_package ul {
    position: absolute;
    list-style: none;

    left: 57%;
    top: 11.5%;

    width: 65%;

    font: 1.8cqh MyriadPro-Regular;
}

#backButton {
    position: absolute;

    top: 0%;
    right: -2%;

    width: 18%;
    height: 3.8574%;;
    
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-color: transparent;
    background-size: contain;
    background-repeat: no-repeat;

    border-width: 0;

    text-decoration-color: goldenrod;
    text-emphasis-color: goldenrod;
    color: white;

    text-transform: uppercase;

    container-type: size;

    pointer-events: all;
}

#backButton span {
    position: absolute;

    left: 58.5cqw;

    font: 4.4cqw MyriadPro-Semi;
    letter-spacing: 0.3cqw;
    transform: translate(-50%, -55%);

    white-space: nowrap;
}

#backButton:hover, #backButton:focus {
    color: goldenrod;

    border-width: 0;
}

.details_header1 {
    position: absolute;

    left: 30.4%;
    top: 7.7%;

    transform: translate(-50%);

    text-transform: uppercase;

    font: 1.2cqh MyriadPro-Regular;
    letter-spacing: 0.05cqh;

    color: white
}

.details_header3 {
    position: absolute;

    left: 40.9%;
    top: 7.7%;

    transform: translate(-50%);

    text-transform: uppercase;

    font: 1.2cqh MyriadPro-Regular;
    letter-spacing: 0.05cqh;

    color: white
}

.punchout {
    background-color: transparent;
}

.punchout-hover {
    animation: punchout-embiggen 1s forwards;
}

.punchout-endhover {
    animation: punchout-emsmollen 0.4s forwards;
}

@keyframes punchout-embiggen {
    from {
        height: 100%;
        width: 150%;
    }
    to {
        height: 110%;
        width: 165%;
    }
}

@keyframes punchout-emsmollen {
    from {
        height: 110%;
        width: 165%;
    }
    to {
        height: 100%;
        width: 150%;
    }
}

#input1-PackageSelection {
    clip-path: polygon(0% 0%, 83.8% 0%, 98.9% 50%, 83.8% 100%, 0% 100%);
}

#input2-PackageSelection {
    clip-path: polygon(1.5% 0%, 86.3% 0%, 98.8% 50%, 86.3% 100%, 1.5% 100%, 14% 0%);
}

#input3-PackageSelection {
    clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%, 12.9% 50%);
}

.input-PackageSelection {
    position: relative;
    height: 100%;
    width: 100%;
    opacity: 0;
    z-index: 2;

    pointer-events: all;
}

.inputImage_package {
    position: absolute;

    left: 50%;
    top: 50%;
    transform: translate(-40%, -50%);

    width: 150%;
    height: 100%;

    opacity: 1;
    z-index: 4;
}

.inputImage-Highlight {
    position: absolute;

    left: 0%;

    width: 100%;
    height: 100%;

    opacity: 0;
    z-index: 5;

    transition: opacity 0.2s 0.3s ease-in-out;
}

.black-background {
    background-color: black;
}

.fadingOutImage1 {
    animation-duration: 0.3s;
    animation-name: fade-out1;
    animation-fill-mode: forwards;
}

.fadingOutImage2 {
    animation-duration: 0.6s;
    animation-name: fade-out2;
    animation-fill-mode: forwards;
}

.fadingOutImage3 {
    animation-duration: 0.9s;
    animation-name: fade-out3;
    animation-fill-mode: forwards;
}

ul {
    list-style: none outside none;
    margin-left: 0;
    padding-left: 0em;
    text-indent: -0.5em;
}

@keyframes fade-in {
    from {
        opacity: 0.1;
    }

    to {
        opacity: 1;
    }
}

@keyframes remove-blocker {

    0%,
    99.99% {
        pointer-events: all;
    }

    100% {
        pointer-events: none;
    }
}

@keyframes fade-out1 {

    from {
        opacity: 1
    }

    to {
        opacity: 0.001
    }
}

@keyframes fade-out2 {

    from,
    50% {
        opacity: 1
    }

    100% {
        opacity: 0
    }
}

@keyframes fade-out3 {

    from,
    66.666% {
        opacity: 1
    }

    100% {
        opacity: 0
    }
}

@keyframes fade-out4 {

    from,
    75% {
        opacity: 1
    }

    100% {
        opacity: 0
    }
}`, "",{"version":3,"sources":["webpack://./src/components/PackageSelection_NEW.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;;IAEb,uBAAuB;IACvB,mBAAmB;;IAEnB,WAAW;IACX,YAAY;;IAEZ,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;;IAEZ,UAAU;;IAEV,gBAAgB;;IAEhB,uBAAuB;IACvB,gBAAgB;IAChB,oBAAoB;;IAEpB,YAAY;AAChB;;AAEA;IACI,kBAAkB;;IAElB,aAAa;IACb,cAAc;;IAEd,SAAS;IACT,0BAA0B;;IAE1B,mBAAmB;IACnB,uBAAuB;;IAEvB,yDAAqE;IACrE,wBAAwB;IACxB,4BAA4B;;IAE5B,UAAU;;;IAGV,UAAU;AACd;;yBAEyB;AACzB;;AAEA;IACI,2DAA2D;AAC/D;;AAEA;IACI,iEAAiE;AACrE;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;;IAElB,aAAa;IACb,YAAY;;IAEZ,+BAA+B;;IAE/B,WAAW;;IAEX,iCAAiC;;IAEjC,oBAAoB;;IAEpB,oBAAoB;;IAEpB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;;IAElB,aAAa;IACb,YAAY;;IAEZ,gBAAgB;;QAEZ,oBAAoB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;;IAElB,aAAa;IACb,YAAY;;IAEZ,kCAAkC;IAClC,QAAQ;;;;IAIR,WAAW;;IAEX,iCAAiC;;IAEjC,oBAAoB;;IAEpB,oBAAoB;;IAEpB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,yDAAyD;AAC7D;;AAEA;IACI,UAAU;IACV,iEAAiE;AACrE;;AAEA;IACI,kBAAkB;;IAElB,yBAAyB;;IAEzB,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,2DAA2D;AAC/D;;AAEA;IACI,UAAU;IACV,iEAAiE;AACrE;;AAEA;IACI,4BAA4B;;IAE5B,aAAa;;IAEb,WAAW;IACX,WAAW;;IAEX,6BAA6B;;IAE7B,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,2DAA2D;AAC/D;;AAEA;IACI,UAAU;IACV,iEAAiE;AACrE;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,wBAAwB;;IAExB,yDAAwE;IACxE,4BAA4B;IAC5B,wBAAwB;;IAExB,UAAU;;IAEV,UAAU;;IAEV,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,YAAY;;IAEZ,wBAAwB;;IAExB,yDAAwE;IACxE,4BAA4B;IAC5B,wBAAwB;;IAExB,UAAU;;IAEV,UAAU;;IAEV,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;;IAET,kBAAkB;IAClB,sBAAsB;;IAEtB,yBAAyB;;IAEzB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;;IAEV,SAAS;;IAET,mCAAmC;IACnC,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;;IAEzB,oBAAoB;IACpB,kBAAkB;;IAElB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;IACd,kBAAkB;;IAElB,SAAS;IACT,0BAA0B;IAC1B,QAAQ;;IAER,UAAU;IACV,WAAW;;IAEX,kCAAkC;IAClC,cAAc;;IAEd,aAAa;;IAEb,yBAAyB;;IAEzB,yBAAyB;IACzB,uBAAuB;;IAEvB,gBAAgB;IAChB,mBAAmB;;IAEnB,oBAAoB;IACpB,8BAA8B;;IAE9B,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,kBAAkB;;IAElB,SAAS;IACT,0BAA0B;IAC1B,UAAU;;IAEV,UAAU;IACV,WAAW;;IAEX,kCAAkC;IAClC,cAAc;;IAEd,aAAa;;IAEb,yBAAyB;IACzB,yBAAyB;IACzB,uBAAuB;;IAEvB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,8BAA8B;;IAE9B,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,UAAU;;IAEV,SAAS;;IAET,YAAY;IACZ,YAAY;;IAEZ,0BAA0B;IAC1B,SAAS;;IAET,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,kBAAkB;;IAElB,YAAY;IACZ,YAAY;;IAEZ,YAAY;;IAEZ,0BAA0B;IAC1B,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;;IAET,kBAAkB;IAClB,sBAAsB;;IAEtB,yBAAyB;;IAEzB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;;IAEV,SAAS;;IAET,2BAA2B;IAC3B,sBAAsB;IACtB,WAAW;IACX,yBAAyB;;IAEzB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;;IAElB,cAAc;;IAEd,UAAU;AACd;;AAEA;IACI,kBAAkB;;IAElB,eAAe;;IAEf,UAAU;AACd;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,8DAA8D;AAClE;;AAEA;IACI,4DAA4D;AAChE;;;;AAIA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;;IAEb,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;;IAEZ,UAAU;;IAEV,2DAA2D;;IAE3D,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;;IAEZ,UAAU;IACV,UAAU;;IAEV,wBAAwB;IACxB,uBAAuB;IACvB,6BAA6B;;IAE7B,oBAAoB;;IAEpB,iBAAiB;;IAEjB,oBAAoB;IACpB,gBAAgB;;IAEhB,mEAAmE;AACvE;;AAEA;IACI,kBAAkB;;IAElB,YAAY;;IAEZ,UAAU;IACV,UAAU;;IAEV,wBAAwB;IACxB,uBAAuB;IACvB,6BAA6B;IAC7B,qBAAqB;;IAErB,oBAAoB;;IAEpB,eAAe;IACf,0BAA0B;;IAE1B,gBAAgB;;IAEhB,wEAAwE;AAC5E;;AAEA;IACI,kBAAkB;;IAElB,YAAY;IACZ,YAAY;;IAEZ,SAAS;;IAET,UAAU;IACV,UAAU;;IAEV,wBAAwB;IACxB,uBAAuB;IACvB,6BAA6B;IAC7B,qBAAqB;;IAErB,oBAAoB;;IAEpB,iEAAiE;AACrE;;AAEA;IACI,UAAU;;IAEV,wBAAwB;IACxB,uBAAuB;IACvB,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA,SAAS;AACT;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;;IAEhB,SAAS;IACT,0BAA0B;IAC1B,WAAW;;IAEX,UAAU;;IAEV,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;;IAEhB,SAAS;IACT,0BAA0B;IAC1B,WAAW;;IAEX,UAAU;IACV,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;;IAElB,WAAW;IACX,YAAY;;IAEZ,SAAS;IACT,OAAO;;IAEP,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;;IAElB,YAAY;IACZ,0BAA0B;IAC1B,OAAO;;IAEP,WAAW;;IAEX,UAAU;IACV,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;;IAElB,WAAW;IACX,YAAY;;IAEZ,SAAS;IACT,OAAO;;IAEP,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;;IAElB,WAAW;IACX,0BAA0B;IAC1B,OAAO;;IAEP,WAAW;;IAEX,UAAU;;IAEV,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;;IAElB,WAAW;IACX,YAAY;;IAEZ,WAAW;IACX,OAAO;;IAEP,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;;IAElB,SAAS;IACT,0BAA0B;IAC1B,OAAO;;IAEP,WAAW;;IAEX,UAAU;;IAEV,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;;IAElB,WAAW;IACX,0BAA0B;IAC1B,OAAO;;IAEP,cAAc;IACd,aAAa;;IAEb,UAAU;IACV,8BAA8B;IAC9B,yBAAyB;IACzB,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;;IAEhB,SAAS;IACT,UAAU;;IAEV,UAAU;;IAEV,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;;IAEhB,SAAS;IACT,UAAU;;IAEV,UAAU;;IAEV,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;;IAElB,OAAO;IACP,UAAU;;IAEV,UAAU;IACV,eAAe;;IAEf,yDAAqE;IACrE,6BAA6B;IAC7B,wBAAwB;IACxB,4BAA4B;;IAE5B,eAAe;;IAEf,gCAAgC;IAChC,8BAA8B;IAC9B,YAAY;;IAEZ,yBAAyB;;IAEzB,oBAAoB;;IAEpB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;;IAElB,aAAa;;IAEb,2BAA2B;IAC3B,sBAAsB;IACtB,gCAAgC;;IAEhC,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;;IAEhB,eAAe;AACnB;;AAEA;IACI,kBAAkB;;IAElB,WAAW;IACX,SAAS;;IAET,0BAA0B;;IAE1B,yBAAyB;;IAEzB,8BAA8B;IAC9B,uBAAuB;;IAEvB;AACJ;;AAEA;IACI,kBAAkB;;IAElB,WAAW;IACX,SAAS;;IAET,0BAA0B;;IAE1B,yBAAyB;;IAEzB,8BAA8B;IAC9B,uBAAuB;;IAEvB;AACJ;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI;QACI,YAAY;QACZ,WAAW;IACf;IACA;QACI,YAAY;QACZ,WAAW;IACf;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,WAAW;IACf;IACA;QACI,YAAY;QACZ,WAAW;IACf;AACJ;;AAEA;IACI,mEAAmE;AACvE;;AAEA;IACI,+EAA+E;AACnF;;AAEA;IACI,iEAAiE;AACrE;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,UAAU;IACV,UAAU;;IAEV,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;;IAElB,SAAS;IACT,QAAQ;IACR,gCAAgC;;IAEhC,WAAW;IACX,YAAY;;IAEZ,UAAU;IACV,UAAU;AACd;;AAEA;IACI,kBAAkB;;IAElB,QAAQ;;IAER,WAAW;IACX,YAAY;;IAEZ,UAAU;IACV,UAAU;;IAEV,yCAAyC;AAC7C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;;IAEI;;QAEI,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;AACJ;;AAEA;;IAEI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;;IAEA;QACI;IACJ;AACJ","sourcesContent":["#packagesRoot {\r\n    position: relative;\r\n    display: flex;\r\n\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n    width: 100%;\r\n    height: 100%;\r\n\r\n    background-color: black;\r\n}\r\n\r\n#packagesParent {\r\n    display: flex;\r\n    aspect-ratio: 16/9;\r\n    width: 100%;\r\n    max-width: 177.778vh;\r\n    max-height: 56.25vw;\r\n    height: auto;\r\n\r\n    opacity: 1;\r\n\r\n    overflow: hidden;\r\n\r\n    justify-content: center;\r\n    align-items: end;\r\n    container-type: size;\r\n\r\n    z-index: 100;\r\n}\r\n\r\n#foreground {\r\n    position: absolute;\r\n\r\n    width: 100cqw;\r\n    height: 100cqh;\r\n\r\n    left: 50%;\r\n    transform: translate(-50%);\r\n\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n    background-image: url(\"../../public/Images/Packages/Packages_BG.png\");\r\n    background-size: contain;\r\n    background-repeat: no-repeat;\r\n\r\n    opacity: 0;\r\n    \r\n\r\n    z-index: 0;\r\n/* \r\n    justify-self: center;\r\n    align-self: center; */\r\n}\r\n\r\n.foreground_IntroAnim {\r\n    animation: fade-in 0.2s ease 0.6s 1 normal forwards running;\r\n}\r\n\r\n.foreground_OutroAnim {\r\n    animation: fade-out1 0.3s ease-out 0.7s 1 normal forwards running;\r\n}\r\n\r\n#carImage {\r\n    position: absolute;\r\n    aspect-ratio: 16/9;\r\n\r\n    width: 111cqw;\r\n    height: auto;\r\n\r\n    transform: translate(0%, -8cqh);\r\n\r\n    z-index: -1;\r\n\r\n    /* box-shadow: none !important; */\r\n\r\n    pointer-events: none;\r\n\r\n    align-self: flex-end;\r\n\r\n    border: none;\r\n}\r\n\r\n#carImageDiv {\r\n    position: absolute;\r\n    aspect-ratio: 16/9;\r\n\r\n    width: 100cqw;\r\n    height: auto;\r\n\r\n    overflow: hidden;\r\n\r\n        pointer-events: none;\r\n}\r\n\r\n#carImage2 {\r\n    position: absolute;\r\n    aspect-ratio: 16/9;\r\n\r\n    width: 118cqw;\r\n    height: auto;\r\n\r\n    transform: translate(-50%, -20cqh);\r\n    left:50%;\r\n\r\n    \r\n\r\n    z-index: -1;\r\n\r\n    /* box-shadow: none !important; */\r\n\r\n    pointer-events: none;\r\n\r\n    align-self: flex-end;\r\n\r\n    border: none;\r\n}\r\n\r\n.carImageClass_Intro {\r\n    opacity: 0;\r\n    animation: fade-in 1s ease 1.2s 1 normal forwards running;\r\n}\r\n\r\n.carImageClass_Outro {\r\n    opacity: 1;\r\n    animation: fade-out1 0.3s ease-out 0.4s 1 normal forwards running;\r\n}\r\n\r\n#backgroundColor {\r\n    position: absolute;\r\n\r\n    background-color: #dddddd;\r\n\r\n    aspect-ratio: 16/9;\r\n    width: 100%;\r\n    max-width: 177.778vh;\r\n    max-height: 56.25vw;\r\n    height: auto;\r\n}\r\n\r\n.backgroundClass_Intro {\r\n    opacity: 0;\r\n    animation: fade-in 0.2s ease 0.2s 1 normal forwards running;\r\n}\r\n\r\n.backgroundClass_Outro {\r\n    opacity: 1;\r\n    animation: fade-out1 0.3s ease-out 0.7s 1 normal forwards running;\r\n}\r\n\r\n#optionHolder {\r\n    /* background-color: aqua; */\r\n    \r\n    display: flex;\r\n\r\n    width: 100%;\r\n    height: 34%;\r\n\r\n    background-color: transparent;\r\n\r\n    flex-direction: row;\r\n    justify-content: center;\r\n}\r\n\r\n.optionHolder_Intro {\r\n    opacity: 0;\r\n    animation: fade-in 0.2s ease 0.9s 1 normal forwards running;\r\n}\r\n\r\n.optionHolder_Outro {\r\n    opacity: 1;\r\n    animation: fade-out1 0.3s ease-out 0.1s 1 normal forwards running;\r\n}\r\n\r\n#option1of2 {\r\n    height: 100%;\r\n    width: 34%;\r\n    margin: 0px 0px 0.3% 0px;\r\n\r\n    background-image: url(../../public/Images/Packages/BG_2Option_Small.png);\r\n    background-repeat: no-repeat;\r\n    background-size: contain;\r\n\r\n    opacity: 1;\r\n\r\n    z-index: 1;\r\n \r\n    container-type: size;\r\n}\r\n\r\n#option2of2 {\r\n    height: 100%;\r\n    width: 49.5%;\r\n\r\n    margin: 0px 0px 0.3% 0px;\r\n\r\n    background-image: url(../../public/Images/Packages/BG_2Option_Large.png);\r\n    background-repeat: no-repeat;\r\n    background-size: contain;\r\n\r\n    opacity: 1;\r\n\r\n    z-index: 1;\r\n\r\n    container-type: size;\r\n}\r\n\r\n#option1of2 h2 {\r\n    position: relative;\r\n    top: 15cqh;\r\n    margin: 0;\r\n\r\n    font: 13cqh Diesel;\r\n    letter-spacing: 0.4cqh;\r\n\r\n    text-transform: uppercase;\r\n\r\n    justify-self: center;\r\n    text-align: center;\r\n}\r\n\r\n#option1of2 h3 {\r\n    position: relative;\r\n    top: 14cqh;\r\n\r\n    margin: 0;\r\n\r\n    font: bold 4.3cqh MyriadPro-Regular;\r\n    letter-spacing: 0.1cqw;\r\n    color: transparent;\r\n    text-transform: uppercase;\r\n\r\n    justify-self: center;\r\n    text-align: center;\r\n\r\n    pointer-events: none;\r\n}\r\n\r\n#option1of2 h3::selection {\r\n    color: transparent;\r\n    background-color: transparent;\r\n}\r\n\r\n#option1of2 .lineBottom {\r\n    top: 30cqh;\r\n}\r\n\r\n#option1of2 button {\r\n    display: block;\r\n    position: relative;\r\n\r\n    left: 50%;\r\n    transform: translate(-50%);\r\n    top: 35%;\r\n\r\n    width: 32%;\r\n    height: 10%;\r\n\r\n    background-color: rgb(136, 46, 46);\r\n    color: #e0e0df;\r\n\r\n    z-index: 1000;\r\n\r\n    font: 4cqh MyriadPro-Bold;\r\n\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.15cqw;\r\n\r\n    box-shadow: none;\r\n    border-style: solid;\r\n\r\n    border-radius: 25cqh;\r\n    border-color: rgb(136, 46, 46);;\r\n\r\n    pointer-events: all;\r\n}\r\n\r\n#option1of2 button:hover {\r\n    background-color: transparent;\r\n    color: black;\r\n}\r\n\r\n#option2of2 button {\r\n    display: block;\r\n    position: relative;\r\n\r\n    left: 50%;\r\n    transform: translate(-50%);\r\n    top: 30.2%;\r\n\r\n    width: 22%;\r\n    height: 10%;\r\n\r\n    background-color: rgb(136, 46, 46);\r\n    color: #e0e0df;\r\n\r\n    z-index: 1000;\r\n\r\n    font: 4cqh MyriadPro-Bold;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.15cqw;\r\n\r\n    box-shadow: none;\r\n    border-style: solid;\r\n    border-radius: 25cqh;\r\n    border-color: rgb(136, 46, 46);\r\n\r\n    pointer-events: all;\r\n}\r\n\r\n#option2of2 button:hover {\r\n    background-color: transparent;\r\n    color: black;\r\n}\r\n\r\n.lineTop {\r\n    display: block;\r\n    position: relative;\r\n    top: 21cqh;\r\n\r\n    margin: 0;\r\n\r\n    width: 90cqw;\r\n    height: 1cqh;\r\n\r\n    transform: translate(-50%);\r\n    left: 50%;\r\n\r\n    opacity: 0.2;\r\n}\r\n\r\n.lineBottom {\r\n    display: block;\r\n    position: relative;\r\n\r\n    width: 90cqw;\r\n    height: 1cqh;\r\n\r\n    opacity: 0.2;\r\n    \r\n    transform: translate(-50%);\r\n    left: 50%;\r\n}\r\n\r\n#option2of2 h2 {\r\n    position: relative;\r\n    top: 15cqh;\r\n    margin: 0;\r\n\r\n    font: 13cqh Diesel;\r\n    letter-spacing: 0.4cqh;\r\n\r\n    text-transform: uppercase;\r\n\r\n    justify-self: center;\r\n    text-align: center;\r\n}\r\n\r\n#option2of2 h3 {\r\n    position: relative;\r\n    top: 14cqh;\r\n\r\n    margin: 0;\r\n\r\n    font: 4.3cqh MyriadPro-Semi;\r\n    letter-spacing: 0.1cqw;\r\n    color: grey;\r\n    text-transform: uppercase;\r\n\r\n    justify-self: center;\r\n    text-align: center;\r\n}\r\n\r\n#option2of2 .lineBottom {\r\n    top: 25cqh;\r\n}\r\n\r\n#option1_Highlight {\r\n    position: absolute;\r\n\r\n    width: 99.7cqw;\r\n\r\n    opacity: 0;\r\n}\r\n\r\n#option2_Highlight {\r\n    position: absolute;\r\n\r\n    width: 99.68cqw;\r\n\r\n    opacity: 0;\r\n}\r\n\r\n.optionFadeOut {\r\n    animation: fade-out1 0.5s ease 0.0s 1 normal forwards running;\r\n}\r\n\r\n.optionFadeIn {\r\n    animation: fade-in 0.7s ease 0s 1 normal forwards running;\r\n}\r\n\r\n.Start_optionFadeIn {\r\n    animation: fade-in 1s ease 1.2s 1 normal forwards running;\r\n}\r\n\r\n.carImage_FadeOut {\r\n    animation: fade-out1 0.25s ease 0.0s 1 normal forwards running;\r\n}\r\n\r\n.carImage_FadeIn {\r\n    animation: fade-in 0.25s ease 0.0s 1 normal forwards running;\r\n}\r\n\r\n\r\n\r\n#interactionBlocker-PackageSelection {\r\n    position: absolute;\r\n    width: 100vw;\r\n    height: 100vh;\r\n\r\n    z-index: 99;\r\n}\r\n\r\n.interactionBlockStart-PackageSelection {\r\n    animation-duration: 1.8s;\r\n    animation-name: remove-blocker;\r\n    animation-fill-mode: forwards;\r\n}\r\n\r\n.interactionBlockEnabled-PackageSelection {\r\n    pointer-events: all;\r\n}\r\n\r\n.interactionBlockDisabled-PackageSelection {\r\n    pointer-events: none;\r\n}\r\n\r\n#backDiv {\r\n    position: absolute;\r\n    aspect-ratio: 16/9;\r\n    width: 100%;\r\n    max-width: 177.778vh;\r\n    max-height: 56.25vw;\r\n    height: auto;\r\n\r\n    opacity: 0;\r\n\r\n    animation: fade-in 0.2s ease 0.6s 1 normal forwards running;\r\n\r\n    pointer-events: none;\r\n}\r\n\r\n#inputDiv1_Package {\r\n    position: relative;\r\n    height: 100%;\r\n    width: 54.2%;\r\n\r\n    z-index: 2;\r\n    opacity: 0;\r\n\r\n    animation-duration: 0.3s;\r\n    animation-name: fade-in;\r\n    animation-fill-mode: forwards;\r\n\r\n    pointer-events: none;\r\n\r\n    margin-right: -8%;\r\n\r\n    object-fit: overflow;\r\n    overflow: hidden;\r\n\r\n    clip-path: polygon(0% 0%, 85.3% 0%, 99.9% 51%, 85.7% 100%, 0% 100%);\r\n}\r\n\r\n#inputDiv2_Package {\r\n    position: relative;\r\n\r\n    height: 100%;\r\n\r\n    z-index: 1;\r\n    opacity: 0;\r\n\r\n    animation-duration: 0.3s;\r\n    animation-name: fade-in;\r\n    animation-fill-mode: forwards;\r\n    animation-delay: 0.4s;\r\n\r\n    pointer-events: none;\r\n\r\n    margin-left: 0%;\r\n    margin-right: -4.94791666%;\r\n\r\n    overflow: hidden;\r\n\r\n    clip-path: polygon(0% 0%, 87% 0%, 100% 51%, 87.6% 100%, 0% 100%, 0% 51%);\r\n}\r\n\r\n#inputDiv3_Package {\r\n    position: relative;\r\n\r\n    height: 100%;\r\n    width: 54.2%;\r\n    \r\n    right: 0%;\r\n\r\n    z-index: 0;\r\n    opacity: 0;\r\n\r\n    animation-duration: 0.3s;\r\n    animation-name: fade-in;\r\n    animation-fill-mode: forwards;\r\n    animation-delay: 0.4s;\r\n\r\n    pointer-events: none;\r\n\r\n    clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%, 12.9% 50%);\r\n}\r\n\r\n.fadeIn5 {\r\n    opacity: 0;\r\n\r\n    animation-duration: 0.3s;\r\n    animation-name: fade-in;\r\n    animation-fill-mode: forwards;\r\n    animation-delay: 1.5s;\r\n}\r\n\r\n/* text */\r\n#inputDiv1_Package h2 {\r\n    text-wrap: nowrap;\r\n}\r\n\r\n#inputDiv2_Package h2 {\r\n    white-space: nowrap;\r\n}\r\n\r\n\r\n#inputDiv3_Package h2 {\r\n    white-space: nowrap; \r\n}\r\n\r\n#inputDiv3_Package h3 {\r\n    white-space: nowrap;\r\n}\r\n\r\n#option1of2 ul li:before {\r\n    content: \"- \";\r\n}\r\n\r\n#option2of2 ul li:before {\r\n    content: \"- \";\r\n}\r\n\r\n#inputDiv2_Package ul {\r\n    position: absolute;\r\n    list-style: none;\r\n\r\n    left: 50%;\r\n    transform: translate(-35%);\r\n    bottom: 20%;\r\n\r\n    width: 60%;\r\n\r\n    z-index: 5;\r\n    color: white;\r\n}\r\n\r\n#inputDiv2_Package ul li:before {\r\n    content: \"- \";\r\n}\r\n\r\n#inputDiv3_Package ul {\r\n    position: absolute;\r\n    list-style: none;\r\n\r\n    left: 50%;\r\n    transform: translate(-45%);\r\n    bottom: 20%;\r\n\r\n    z-index: 5;\r\n    color: white;\r\n    text-wrap: nowrap;\r\n}\r\n\r\n#inputDiv3_Package ul li:before {\r\n    content: \"- \";\r\n}\r\n\r\n#optionsContainer1_package {\r\n    position: absolute;\r\n\r\n    width: 100%;\r\n    height: 100%;\r\n\r\n    left: 27%;\r\n    top: 0%;\r\n\r\n    container-type: size;\r\n}\r\n\r\n#optionsContainer1_package h2 {\r\n    position: absolute;\r\n\r\n    left: 32.29%;\r\n    transform: translate(-50%);\r\n    top: 1%;\r\n\r\n    margin: 0px;\r\n\r\n    z-index: 5;\r\n    font: 4cqh Diesel;\r\n    letter-spacing: 0.05em;\r\n    text-transform: uppercase;\r\n}\r\n\r\n#optionsContainer2_package {\r\n    position: absolute;\r\n\r\n    width: 100%;\r\n    height: 100%;\r\n\r\n    left: 16%;\r\n    top: 0%;\r\n\r\n    container-type: size;\r\n}\r\n\r\n#optionsContainer2_package h2 {\r\n    position: absolute;\r\n\r\n    left: 58.2%;\r\n    transform: translate(-50%);\r\n    top: 1%;\r\n\r\n    margin: 0px;\r\n\r\n    z-index: 5;\r\n\r\n    font: 4cqh Diesel;\r\n    letter-spacing: 0.05em;\r\n    text-transform: uppercase;\r\n}\r\n\r\n#optionsContainer3_package {\r\n    position: absolute;\r\n\r\n    width: 100%;\r\n    height: 100%;\r\n\r\n    left: 16.2%;\r\n    top: 0%;\r\n\r\n    container-type: size;\r\n}\r\n\r\n#optionsContainer3_package h2 {\r\n    position: absolute;\r\n\r\n    left: 43%;\r\n    transform: translate(-50%);\r\n    top: 1%;\r\n\r\n    margin: 0px;\r\n\r\n    z-index: 5;\r\n\r\n    font: 4.0cqh Diesel;\r\n    letter-spacing: 0.05em;\r\n    text-transform: uppercase;\r\n}\r\n\r\n#optionsContainer3_package h3 {\r\n    position: absolute;\r\n\r\n    left: 57.9%; \r\n    transform: translate(-50%);\r\n    top: 5%;\r\n\r\n    padding-top: 0;\r\n    margin-top: 0;\r\n\r\n    z-index: 5;\r\n    font: 1.2cqh MyriadPro-Regular;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.3cqh;\r\n    color: black;\r\n}\r\n\r\n#optionsContainer2_package ul {\r\n    position: absolute;\r\n    list-style: none;\r\n\r\n    left: 55%;\r\n    top: 11.5%;\r\n\r\n    width: 55%;\r\n\r\n    font: 1.8cqh MyriadPro-Regular;\r\n}\r\n\r\n#optionsContainer3_package ul {\r\n    position: absolute;\r\n    list-style: none;\r\n\r\n    left: 57%;\r\n    top: 11.5%;\r\n\r\n    width: 65%;\r\n\r\n    font: 1.8cqh MyriadPro-Regular;\r\n}\r\n\r\n#backButton {\r\n    position: absolute;\r\n\r\n    top: 0%;\r\n    right: -2%;\r\n\r\n    width: 18%;\r\n    height: 3.8574%;;\r\n    \r\n    background-image: url(../../public/Images/Misc/PackageBackButton.png);\r\n    background-color: transparent;\r\n    background-size: contain;\r\n    background-repeat: no-repeat;\r\n\r\n    border-width: 0;\r\n\r\n    text-decoration-color: goldenrod;\r\n    text-emphasis-color: goldenrod;\r\n    color: white;\r\n\r\n    text-transform: uppercase;\r\n\r\n    container-type: size;\r\n\r\n    pointer-events: all;\r\n}\r\n\r\n#backButton span {\r\n    position: absolute;\r\n\r\n    left: 58.5cqw;\r\n\r\n    font: 4.4cqw MyriadPro-Semi;\r\n    letter-spacing: 0.3cqw;\r\n    transform: translate(-50%, -55%);\r\n\r\n    white-space: nowrap;\r\n}\r\n\r\n#backButton:hover, #backButton:focus {\r\n    color: goldenrod;\r\n\r\n    border-width: 0;\r\n}\r\n\r\n.details_header1 {\r\n    position: absolute;\r\n\r\n    left: 30.4%;\r\n    top: 7.7%;\r\n\r\n    transform: translate(-50%);\r\n\r\n    text-transform: uppercase;\r\n\r\n    font: 1.2cqh MyriadPro-Regular;\r\n    letter-spacing: 0.05cqh;\r\n\r\n    color: white\r\n}\r\n\r\n.details_header3 {\r\n    position: absolute;\r\n\r\n    left: 40.9%;\r\n    top: 7.7%;\r\n\r\n    transform: translate(-50%);\r\n\r\n    text-transform: uppercase;\r\n\r\n    font: 1.2cqh MyriadPro-Regular;\r\n    letter-spacing: 0.05cqh;\r\n\r\n    color: white\r\n}\r\n\r\n.punchout {\r\n    background-color: transparent;\r\n}\r\n\r\n.punchout-hover {\r\n    animation: punchout-embiggen 1s forwards;\r\n}\r\n\r\n.punchout-endhover {\r\n    animation: punchout-emsmollen 0.4s forwards;\r\n}\r\n\r\n@keyframes punchout-embiggen {\r\n    from {\r\n        height: 100%;\r\n        width: 150%;\r\n    }\r\n    to {\r\n        height: 110%;\r\n        width: 165%;\r\n    }\r\n}\r\n\r\n@keyframes punchout-emsmollen {\r\n    from {\r\n        height: 110%;\r\n        width: 165%;\r\n    }\r\n    to {\r\n        height: 100%;\r\n        width: 150%;\r\n    }\r\n}\r\n\r\n#input1-PackageSelection {\r\n    clip-path: polygon(0% 0%, 83.8% 0%, 98.9% 50%, 83.8% 100%, 0% 100%);\r\n}\r\n\r\n#input2-PackageSelection {\r\n    clip-path: polygon(1.5% 0%, 86.3% 0%, 98.8% 50%, 86.3% 100%, 1.5% 100%, 14% 0%);\r\n}\r\n\r\n#input3-PackageSelection {\r\n    clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%, 12.9% 50%);\r\n}\r\n\r\n.input-PackageSelection {\r\n    position: relative;\r\n    height: 100%;\r\n    width: 100%;\r\n    opacity: 0;\r\n    z-index: 2;\r\n\r\n    pointer-events: all;\r\n}\r\n\r\n.inputImage_package {\r\n    position: absolute;\r\n\r\n    left: 50%;\r\n    top: 50%;\r\n    transform: translate(-40%, -50%);\r\n\r\n    width: 150%;\r\n    height: 100%;\r\n\r\n    opacity: 1;\r\n    z-index: 4;\r\n}\r\n\r\n.inputImage-Highlight {\r\n    position: absolute;\r\n\r\n    left: 0%;\r\n\r\n    width: 100%;\r\n    height: 100%;\r\n\r\n    opacity: 0;\r\n    z-index: 5;\r\n\r\n    transition: opacity 0.2s 0.3s ease-in-out;\r\n}\r\n\r\n.black-background {\r\n    background-color: black;\r\n}\r\n\r\n.fadingOutImage1 {\r\n    animation-duration: 0.3s;\r\n    animation-name: fade-out1;\r\n    animation-fill-mode: forwards;\r\n}\r\n\r\n.fadingOutImage2 {\r\n    animation-duration: 0.6s;\r\n    animation-name: fade-out2;\r\n    animation-fill-mode: forwards;\r\n}\r\n\r\n.fadingOutImage3 {\r\n    animation-duration: 0.9s;\r\n    animation-name: fade-out3;\r\n    animation-fill-mode: forwards;\r\n}\r\n\r\nul {\r\n    list-style: none outside none;\r\n    margin-left: 0;\r\n    padding-left: 0em;\r\n    text-indent: -0.5em;\r\n}\r\n\r\n@keyframes fade-in {\r\n    from {\r\n        opacity: 0.1;\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n@keyframes remove-blocker {\r\n\r\n    0%,\r\n    99.99% {\r\n        pointer-events: all;\r\n    }\r\n\r\n    100% {\r\n        pointer-events: none;\r\n    }\r\n}\r\n\r\n@keyframes fade-out1 {\r\n\r\n    from {\r\n        opacity: 1\r\n    }\r\n\r\n    to {\r\n        opacity: 0.001\r\n    }\r\n}\r\n\r\n@keyframes fade-out2 {\r\n\r\n    from,\r\n    50% {\r\n        opacity: 1\r\n    }\r\n\r\n    100% {\r\n        opacity: 0\r\n    }\r\n}\r\n\r\n@keyframes fade-out3 {\r\n\r\n    from,\r\n    66.666% {\r\n        opacity: 1\r\n    }\r\n\r\n    100% {\r\n        opacity: 0\r\n    }\r\n}\r\n\r\n@keyframes fade-out4 {\r\n\r\n    from,\r\n    75% {\r\n        opacity: 1\r\n    }\r\n\r\n    100% {\r\n        opacity: 0\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
